import axios from 'axios';
import {
  ISubdivisionCollection,
  ISubdivisionListParams,
  ISubdivision,
  ICreateSubdivisionPayload,
  IDeleteSubdivisionPayload,
  IUpdateSubdivisionPayload,
  ISubdivisionParams,
} from 'entities/Subdivision/Subdivision.models';

const basePath = 'subdivision';

export const subdivisionTransport = {
  get: (params: ISubdivisionListParams): Promise<ISubdivisionCollection> => axios.get(`${basePath}`, { params }),
  getById: ({ id }: ISubdivisionParams): Promise<ISubdivision> => axios.get(`${basePath}/${id}`),
  create: (payload: ICreateSubdivisionPayload): Promise<ISubdivision> => axios.post(`${basePath}`, payload),
  update: (payload: IUpdateSubdivisionPayload): Promise<ISubdivision> => axios.patch(`${basePath}`, payload),
  delete: (payload: IDeleteSubdivisionPayload): Promise<ISubdivision> => axios.delete(`${basePath}`, { data: payload }),
};
